module.exports = __webpack_public_path__ + "assets_1773901505253/img/guide_android.4b8e8721.png";